import React, { useState, useEffect, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import style from './NonFaceLoginMain.module.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import MSG from '../../../../constants/message';
import URL, { AFTCR_OS_AT, SERVER_URL } from '../../../../constants/url';
import logo from '../../../../images/common/logo_landing_new.svg';
import iconClose from '../../../../images/common/i_close_btn_main.svg';
import iconWarning from '../../../../images/common/i_warning.svg';
import ToastPopup from '../../../../components/comm/ToastPopup';
import { getDpAuthRefeshTokenSimple, getDpAuthSignin } from '../../../../assets/js/comm';


const NonFaceLoginMain = (props) => {

    // 운영모드
    const operateMod = AFTCR_OS_AT;
    const user = sessionStorage.getItem("loginUser");

    const AFTCR_ID = "AFTCR_ID";
    const AFTCR_SAVE_ID_FLAG = "AFTCR_SAVE_ID_FLAG";
    const AFTCR_CRTFC_TKN = "AFTCR_CRTFC_TKN";

    const navigate = useNavigate();

    const location = useLocation();
    const { state } = location;

    // 사용자 ID/PW
    const [ userRequest, setUserRequest ] = useState(
        { usrId : localStorage.getItem(AFTCR_ID), usrPswd : "", pushToken: "" });
    // 리프레쉬 토큰
    const [ userRequest2, setUserRequest2 ] = useState(
        { crtfcTknVal: localStorage.getItem(AFTCR_CRTFC_TKN) }
    )
    /*  */
    const [ loginUser, setLoginUser ] = useState({});
    const [ saveIdFlag, setSaveIdFlag ] = useState(false);

    const handleSaveIdFlag = () => {
        localStorage.setItem(AFTCR_SAVE_ID_FLAG, !saveIdFlag);
        setSaveIdFlag(!saveIdFlag);
    };
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    // password view
    const [pwView, setPwView] = useState(false);

    // 화면초기화 useRef 선언
    const isInitialRender = useRef(true);

    const [noticeClosed, setNoticeClosed] = useState(false);
    
    const handleCloseNotice = () => {
        setNoticeClosed(true);
    };


    let idFlag;
    try {
        idFlag = JSON.parse(localStorage.getItem(AFTCR_SAVE_ID_FLAG));
    }
    catch(err) {
        idFlag = null;
    }

    const handlePwView = () => {
        setPwView(!pwView);
    }

    useEffect(() => {

        if(state?.refreshAt === false) {
            isInitialRender.current = false;
            //state.refreshAt = true;
        }
        if (idFlag === null) {
            setSaveIdFlag(false);
            idFlag = false;
        }
        if (idFlag !== null) setSaveIdFlag(idFlag);
        if (idFlag === false) {
            localStorage.setItem(AFTCR_ID, "");
            localStorage.setItem(AFTCR_CRTFC_TKN, "");
        } else {
            localStorage.setItem(AFTCR_ID, userRequest?.usrId );
            if( userRequest2.crtfcTknVal && isInitialRender.current ) {
                handleFormSubmit2();
                isInitialRender.current = false;
            }
        }
        if( user && user?.usrHsptlMap?.length > 0 ) {
            navigate(URL.CONTACTLESS_MAIN);
        }

    }, [idFlag]);

    const handleFormSubmit = (e) => {

        if( userRequest.usrId === undefined || userRequest.usrId === null || userRequest.usrId === '' ) {
            setToastMessage('Please enter your ID');
            setToast(true);
            return;
        }

        if( userRequest.usrPswd === undefined || userRequest.usrPswd === null || userRequest.usrPswd === '' ) {
            setToastMessage('Please enter your Password');
            setToast(true);
            return;
        }

        //if( SERVER_URL.indexOf("localhost") < 0 ) { // 운영모드
        if( operateMod ) {
            console.log( "===========> Aftercare Operate Mode : OS Mode ");
            getDpAuthSignin(userRequest)
                .then( async (res) => {
                    if (res?.accessToken !== undefined && res?.accessToken !== "") {
                        const jToken = res?.accessToken;
                        const refreshToken = res?.refreshToken;
                        const requestLoginUrl = "/signup/loginUser"; //"/signup/user";

                        const requestOptions = {
                            headers: {
                                Authorization: `Bearer ${jToken}`,
                            }
                            , params: {
                                refreshToken: refreshToken
                            }
                        }
                        const loginInfo = {
                            ...userRequest,
                            usrNm: res?.displayName
                        }

                        await axiosApi.post(requestLoginUrl, loginInfo, requestOptions)
                            .then((res) => {
                                //console.log( "=============> aftcrUser : ", res.data.result.aftcrUser );
                                if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                                    const aftcrUser = res.data.result.aftcrUser;

                                    if (aftcrUser?.usrSeCd === "17") { // 비대면사용자만 로그인 허용해준다.

                                        if (saveIdFlag) localStorage.setItem(AFTCR_ID, aftcrUser?.usrId);
                                        setLoginUser(aftcrUser);
                                        sessionStorage.setItem('loginUser', JSON.stringify(aftcrUser));
                                        localStorage.setItem('jToken', jToken);
                                        if (saveIdFlag) {
                                            localStorage.setItem(AFTCR_CRTFC_TKN, refreshToken);
                                        }
                                        if (aftcrUser.usrHsptlMap.length > 0) {
                                            // 정상케이스
                                            navigate(URL.CONTACTLESS_MAIN);
                                        } else {
                                            // 해당부분은 맵핑된 병원이 없을 경우,
                                            // 일반적으로 해외 비대면에선 이쪽으로 빠지는 케이스가 있을수 없다..
                                            setToastMessage('Patient information cannot be verified. Please contact the administrator.'); // 환자정보가 확인되지 않습니다. 관리자에게 문의하십시오.
                                            setToast(true);
                                        }
                                    } else {
                                        setToastMessage("Available to overseas patients only.");
                                        setToast(true);
                                        return false;
                                    }
                                } else {
                                    setToastMessage(MSG.ERR_SIGNIN_E);
                                    setToast(true);
                                    return false;
                                }
                            })
                            .catch((err) => {
                                console.log(" ================> RCV_ERROR_SERVER ", err);
                            })
                    } else {
                        alert(MSG.ERR_PSSUSR_E + "\n " + MSG.ERR_AUTH_E);
                    }
                })
                .catch( (err) => {
                    console.log(" ===========> err : ", err );
                    if(err.response.status === Number(CODE.RCV_BAD_UNAUTH)) {
                        console.log( " ==========> RCV_BAD_UNAUTH " );
                        //alert(MSG.ERR_UNSIGN + '\n' + MSG.ERR_PSSUSR + 'zzz');
                        setToastMessage(MSG.ERR_PSSUSR_E);
                        setToast(true);
                    }
                });

            // 2.  aftercare데이터가 없을 경우에는, aftercare사용 등록 페이지로 이동 !!
            // 로컬에서 필요시 사용!
        } else { // 로컬모드
            console.log( "===========> Aftercare Operate Mode : Dev Mode ");

            const requestLoginUrl = "/signup/actionLoginUserLocal";

            axiosApi.post(requestLoginUrl, userRequest)
                .then((res) => { // 응답
                    if (res.data.resultCode === CODE.RCV_SUCCESS) {

                        const aftcrUser = res.data.result.aftcrUser;
                        //const aftcrUserMenu = res.data.aftcrUserMenu;

                        setLoginUser(aftcrUser);
                        sessionStorage.setItem('loginUser', JSON.stringify(aftcrUser));

                        if (saveIdFlag) localStorage.setItem(AFTCR_ID, aftcrUser?.usrId);
                        navigate(URL.CONTACTLESS_MAIN);

                    } else {
                        //alert(res.data.resultMessage);
                        setToastMessage('Your ID or password is incorrect');
                        setToast(true);
                    }
                })
                .catch(err => console.error("=============> Login Error Obj : ", err))
        }
    };

    /**
     * 세션유지 자동로그인
     * @returns {Element}
     */
    const handleFormSubmit2 = () => {

        getDpAuthRefeshTokenSimple(userRequest2.crtfcTknVal) // 간소화 버전 처리
            .then( (data) => {
                //console.log( " ===========> handleFormSubmit2 / getDpAuthRefeshTokenSimple  :: ", data );
                const { accessToken, refreshToken } = data;
                localStorage.setItem("jToken", accessToken);
                const requestCdssUrl = SERVER_URL + "/signup/saveRefreshToken";

                const userReq = {
                    crtfcTknVal: refreshToken
                }
                const requestOptions = {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
                axiosApi.post(requestCdssUrl, userReq, requestOptions)
                    .then((resp) => {
                        if (Number(resp.data.resultCode) === Number(CODE.RCV_SUCCESS)) {

                            const aftcrUser = resp.data.result.userInfo;

                            if (aftcrUser?.usrSeCd === "17") { // 비대면사용자만 로그인 허용해준다.
                                localStorage.setItem("jToken", accessToken);
                                localStorage.setItem(AFTCR_CRTFC_TKN, refreshToken);
                                sessionStorage.setItem("loginUser", JSON.stringify(aftcrUser));

                                if (aftcrUser.usrHsptlMap.length > 0) {
                                    // 정상케이스
                                    setTimeout(() => {
                                        navigate(URL.CONTACTLESS_MAIN)
                                    }, 2000);
                                } else {
                                    // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결 페이지가 뜨도록 조정해야함.
                                    setTimeout(() => {
                                        //navigate(URL.HOSPITAL_LINK);
                                        setToastMessage("Refresh token update failed.");
                                        setToast(true);
                                        localStorage.setItem("jToken", "");
                                        localStorage.setItem(AFTCR_CRTFC_TKN, "");
                                        sessionStorage.setItem("loginUser", JSON.stringify({}));
                                    }, 2000);
                                }
                            } else {
                                setToastMessage("Available to overseas patients only.");
                                setToast(true);
                                return false;
                            }
                        } else {
                            setToastMessage("Refresh token update failed.");
                            setToast(true);
                            localStorage.setItem("jToken", "");
                            localStorage.setItem(AFTCR_CRTFC_TKN, "");
                            sessionStorage.setItem("loginUser", JSON.stringify({}));
                            //sessionStorage.setItem('loginUserMenu', JSON.stringify({}));
                            navigate(URL.NONFACE_LOGIN_MAIN);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setToastMessage("Failed to update credentials.");
                        setToast(true);
                        localStorage.setItem("jToken", "");
                        localStorage.setItem(AFTCR_CRTFC_TKN, "");
                        sessionStorage.setItem("loginUser", JSON.stringify({}));
                        //sessionStorage.setItem('loginUserMenu', JSON.stringify({}));
                        navigate(URL.NONFACE_LOGIN_MAIN);
                    });
            })
            .catch(err => { console.log(err);
                setToastMessage('Failed to retrieve credentials.');
                setToast(true);
                localStorage.setItem("jToken", "");
                localStorage.setItem(AFTCR_CRTFC_TKN, "");
                sessionStorage.setItem("loginUser", JSON.stringify({}));
                navigate(URL.NONFACE_LOGIN_MAIN);
            });
    }

    /**
     * 푸시 기능부
     */
    const getNativAlrmPermission = () => {
        // 알람권한 및 파이어베이스 푸시토큰 발급 함수
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView?.postMessage(
                JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
            );
        }
    };

    useEffect(() => {
        getNativAlrmPermission();
    }, []);

    useEffect(() => {

        const handleNativeMessage = async (event) => {
            try {
                // 메시지 파싱
                const data = typeof event.data === 'string'
                    ? JSON.parse(event.data)
                    : event.data;

                if (!data.type) {
                    console.warn('⚠️ type 필드가 없는 메시지 받음:', data);
                    console.warn('⚠️ 이는 RN에서 type을 누락한 것으로 보입니다');
                    return; // type이 없으면 처리하지 않음
                }

                if (data.type === 'NOTIFICATION_PERMISSION_RESULT') {
                    // RN 에서 결과로 넘겨주는 알람 권한 및 파이어베이스 토큰
                    if (data.granted && data.token) {
                        console.log('✅ 권한 허용됨, 토큰 받음:', data.token);

                        try {

                            setUserRequest( { ...userRequest, pushToken: data.token } );
                            /*
                                최종적으로 토큰 받고 저장하는 로직 {data.token}
                            */
                            // console.log('📤 토큰 서버 전송 완료');

                        } catch (error) {
                            console.error('❌ 토큰 서버 전송 실패:', error);

                        }
                    } else if (data.granted && !data.token) {
                        console.log('⚠️ 권한은 허용됐지만 토큰이 없음 (재확인 메시지)');

                    } else {
                        console.log('❌ 권한 거부됨');
                    }

                } else if (data.type === 'NOTIFICATION_PERMISSION_STATUS') {
                    console.log('📋 권한 상태 확인 메시지 받음');
                    console.log('📋 granted:', data.granted);
                    console.log('📋 origin:', data.origin);

                    /* UI업데이트용 */
                }
            } catch (error) {
                console.error('메시지 처리 오류:', error);
            }
        };

        window.addEventListener('message', handleNativeMessage);
        return () => window.removeEventListener('message', handleNativeMessage);
    }, []);


    useEffect(() => {
        if (location.state && location.state.passwordChanged) {
            setToastMessage('Your password has been changed.');
            setToast(true);
        }
    }, [location.state]);

    return (
        <>
            <HeadSub title="아이디로 로그인" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-pad="normal">

                    
                        <div
                            className={`${style['notice-box']} ${noticeClosed ? style['noticeClosed'] : ''}`}
                            role="status"
                        >
                            <div className={style['notice-head']}>
                                <p className={style['notice-tit']}>Online Doctor Consultation Login</p>
                                <button
                                    type="button"
                                    className={style['notice-close']}
                                    onClick={handleCloseNotice}
                                    aria-label="Close notice"
                                >
                                    <img src={iconClose} alt="닫기 버튼" />
                                </button>
                            </div>

                            <div className={style['notice-divider']} />

                            <div className={style['notice-body']}>
                                <img src={iconWarning} alt="참고사항 아이콘" />
                                <p className={style['notice-desc']}>
                                    Only for international patients residing outside Korea
                                </p>
                            </div>
                        </div>
                    

                    <div className={style['layout-box']} data-notice={noticeClosed ? 'off' : 'on'}>

                        <div className={style['logo-box']}>
                            <h2>
                                <img src={logo} alt="" />
                            </h2>
                        </div>

                        <div className={style['mid-box']}>
                            <div className={style['input-box']}>
                                <span className={style['input-tit']}>ID</span>
                                <span className={style['in-box']}>
                                    <input
                                        type="text"
                                        placeholder='Enter your ID'
                                        value={userRequest?.usrId || ""}
                                                onChange={e => {
                                                    const value = e.target.value;
                                                    if (value.length <= 20) {
                                                    setUserRequest({ ...userRequest, usrId: value });
                                                    }
                                                }}
                                        maxLength={20}
                                    />
                                </span>
                            </div>
                            <div className={style['input-box']}>
                                <span className={style['input-tit']}>Password</span>
                                <span className={style['in-box']}>
                                    <input type="password" placeholder='Enter your password'
                                           onChange={ e => setUserRequest( { ...userRequest, usrPswd: e.target.value }) }
                                           onKeyPress={ (e) => {
                                               if(e.key === "Enter") {
                                                   handleFormSubmit();
                                               }
                                           }}
                                           maxLength={20}
                                    />
                                </span>
                            </div>

                            <div className={style['chk-id-box']}>
                                <div className="chkbox-custom" data-chkbox="basic">
                                    <input type="checkbox" name="chkId" id="chkId" onChange={handleSaveIdFlag}
                                           checked={saveIdFlag}
                                    />
                                    <label htmlFor="chkId">
                                        <div className={style['txt-box']}>
                                            <p>Keep me logged in</p>
                                        </div>
                                    </label>
                                </div>

                            </div>

                            <div className={style['fider-box']}>
                                <button onClick={()=> navigate(URL.NONFACE_FINDID)}>Find ID</button>
                                <button onClick={()=> navigate(URL.NONFACE_FINDPASSWORD)}>Find Password</button>
                            </div>

                        </div>
                            <div className={style['btns-box']}>
                                <button className='btn' data-btn-type="fill-main" data-btn-size='lg' data-btn-width='full' onClick={handleFormSubmit}>
                                    <span>Log In</span>
                                </button>
                                <button className='btn' data-btn-type="fill-main-sub" data-btn-size='lg' data-btn-width='full' onClick={()=> navigate(URL.NONFACE_AGREE_CONDITIONS)}>
                                    <span>Sign Up</span>
                                </button>
                            </div>

                    </div>

                    {toast && (
                        <ToastPopup
                            message={toastMessage}
                            setToast={setToast}
                            position="center"
                            opacity="90"
                        />
                    )}



                </div>
            </div>
        </>
        )

}

export default NonFaceLoginMain;
